module.exports = __webpack_public_path__ + "img/pj-j6.4fed7581.jpg";